var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 23,
    width: 2,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 23,
    width: 2,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 30,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 30,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 34,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 54,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 34,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 38,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 38,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,2h3V0H1C0.448,0,0,0.448,0,1v4h2V2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,0h-4v2h3v3h2V1C64,0.448,63.552,0,63,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,59H0v4c0,0.552,0.448,1,1,1h4v-2H2V59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,62h-3v2h4c0.552,0,1-0.448,1-1v-4h-2V62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,5v12c0,0.552,0.448,1,1,1h12c0.552,0,1-0.448,1-1V5c0-0.552-0.448-1-1-1H5C4.448,4,4,4.448,4,5z M6,6h10v10H6V6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,8H9C8.448,8,8,8.448,8,9v4c0,0.552,0.448,1,1,1h4c0.552,0,1-0.448,1-1V9C14,8.448,13.552,8,13,8z M12,12h-2v-2h2V12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,18h12c0.552,0,1-0.448,1-1V5c0-0.552-0.448-1-1-1H47c-0.552,0-1,0.448-1,1v12C46,17.552,46.448,18,47,18z M48,6h10v10 H48V6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,8h-4c-0.552,0-1,0.448-1,1v4c0,0.552,0.448,1,1,1h4c0.552,0,1-0.448,1-1V9C56,8.448,55.552,8,55,8z M54,12h-2v-2h2V12z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,46H5c-0.552,0-1,0.448-1,1v12c0,0.552,0.448,1,1,1h12c0.552,0,1-0.448,1-1V47C18,46.448,17.552,46,17,46z M16,58H6V48 h10V58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,56h4c0.552,0,1-0.448,1-1v-4c0-0.552-0.448-1-1-1H9c-0.552,0-1,0.448-1,1v4C8,55.552,8.448,56,9,56z M10,52h2v2h-2V52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,19h-7V7h-2v13c0,0.552,0.448,1,1,1h8V19z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 12,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 8,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 19,
    width: 2,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,25H8v2h9v4h2v-5C19,25.448,18.552,25,18,25z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 20,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 18,
    width: 2,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 28,
    width: 9,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,29h-2v10h-3v2h4c0.552,0,1-0.448,1-1V29z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 18,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 33,
    width: 2,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 42,
    width: 9,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,28h2v-4c0-0.552-0.448-1-1-1h-5v2h4V28z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 33,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 32,
    width: 2,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 42,
    width: 9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 38,
    width: 9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 52,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 48,
    width: 9,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,44v-5c0-0.552-0.448-1-1-1H25v2h9v4H36z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 32,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 34,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 53,
    width: 2,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 58,
    width: 3,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 52,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,44c0-0.552-0.448-1-1-1H49v2h10v6h2V44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,56v-5c0-0.552-0.448-1-1-1H36v2h10v4H48z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 47,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 58,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 51,
    width: 2,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 46,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,36h5v-2h-4v-6h-2v7C46,35.552,46.448,36,47,36z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 30,
    width: 5,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 20,
    width: 3,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 20,
    width: 2,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 25,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,17h4c0.552,0,1-0.448,1-1V3h-2v12h-3V17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,5h15V3H23c-0.552,0-1,0.448-1,1v5h2V5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,24h7c0.552,0,1-0.448,1-1v-8h-2v7h-6V24z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 23,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 54,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 58,
    width: 9,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,58h-2v2h3c0.552,0,1-0.448,1-1v-8h-2V58z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 42,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 42,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 38,
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 43,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 46,
    width: 3,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 38,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 34,
    width: 3,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 34,
    width: 5,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 29,
    width: 2,
    height: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.a163dfe67665a049c20cea429d3c318a.svg";
export { ForwardRef as ReactComponent };